import {FooterTabFragment, FooterTabFragmentProps, FooterTabFragmentState} from "./FooterTabFragment";
import React, {ReactElement} from "react";
import {StyledContainer} from "./StyledComponents";
import {Box, Card} from "@mui/material";
import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "./BaseApp";
import {AboutFragment} from "./AboutFragment";
import {BaseFragmentProps} from "./BaseFragment";
import {SettingsFragmentContentUtil} from "./SettingsFragmentContentUtil";
import {LocalCache} from "./LocalCache";

export type BaseSettingsFooterTabFragmentProps = FooterTabFragmentProps & {}

export type BaseSettingsFooterTabFragmentState = FooterTabFragmentState & {}

export abstract class BaseSettingsFooterTabFragment<P extends BaseSettingsFooterTabFragmentProps = BaseFragmentProps, S extends BaseSettingsFooterTabFragmentState = BaseSettingsFooterTabFragmentState> extends FooterTabFragment<P, S> {

  getTitle(): string {
    return "Settings";
  }

  renderContent(): ReactElement {
    return <StyledContainer>
      {this.renderSettingsContent()}
      {this.renderSeparator()}
      <Card>
        <Box style={{display: "flex", flexDirection: "column"}}>
          {this.renderAction("Rate app / Send feedback", () => {
            BaseApp.CONTEXT.showDialog({flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK}, () =>
              <AboutFragment/>)
          })}
        </Box>
      </Card>
    </StyledContainer>
  }

  protected abstract renderSettingsContent(): ReactElement;

  protected renderSeparator() {
    return SettingsFragmentContentUtil.renderSeparator();
  }

  protected renderGroupTitle(text: string) {
    return SettingsFragmentContentUtil.renderGroupTitle(text);
  }

  protected renderToggle(text: string, value: boolean, onToggle: (value: boolean) => void) {
    return SettingsFragmentContentUtil.renderToggle(text, value, onToggle);
  }

  protected renderAction(text: string, onClick: () => void) {
    return SettingsFragmentContentUtil.renderAction(text, onClick);
  }
}
